import paintingImage1 from "../assets/images/paintings/painting1.png";
import paintingImage2 from "../assets/images/paintings/painting2.png";
import paintingImage3 from "../assets/images/paintings/painting3.png";

export const paintings = [
  {
    id: 1,
    image: paintingImage1,
    title: "Title Of Artwork",
    artistFullName: "John Doe",
    country: "Artsakh",
    sizes: "120x150",
    material: "Oil",
    price: "€2.805",
  },
  {
    id: 2,
    image: paintingImage2,
    title: "Title Of Artwork",
    artistFullName: "John Doe",
    country: "Artsakh",
    sizes: "120x150",
    material: "Oil",
    price: "€2.805",
  },
  {
    id: 3,
    image: paintingImage3,
    title: "Title Of Artwork",
    artistFullName: "John Doe",
    country: "Artsakh",
    sizes: "120x150",
    material: "Oil",
    price: "€2.805",
  },
  {
    id: 4,
    image: paintingImage1,
    title: "Title Of Artwork",
    artistFullName: "John Doe",
    country: "Artsakh",
    sizes: "120x150",
    material: "Oil",
    price: "€2.805",
  },
  {
    id: 5,
    image: paintingImage2,
    title: "Title Of Artwork",
    artistFullName: "John Doe",
    country: "Artsakh",
    sizes: "120x150",
    material: "Oil",
    price: "€2.805",
  },
  {
    id: 6,
    image: paintingImage3,
    title: "Title Of Artwork",
    artistFullName: "John Doe",
    country: "Artsakh",
    sizes: "120x150",
    material: "Oil",
    price: "€2.805",
  },
  {
    id: 7,
    image: paintingImage1,
    title: "Title Of Artwork",
    artistFullName: "John Doe",
    country: "Artsakh",
    sizes: "120x150",
    material: "Oil",
    price: "€2.805",
  },
  {
    id: 8,
    image: paintingImage2,
    title: "Title Of Artwork",
    artistFullName: "John Doe",
    country: "Artsakh",
    sizes: "120x150",
    material: "Oil",
    price: "€2.805",
  },
];
